export interface CmpsScoreSectionData {
    scoreLabel: string;
    scoreValue: string;
}
export interface CmpsScoreSectionTrendData {
    trend: CmpsScoreSectionTrendType;
    trendValue: string;
    trendColor: string;
    trendTooltip: CmpsScoreSectionTrendTooltipValue[];
}
export enum CmpsScoreSectionTrendType {
    DOWN,
    UP,
    NO_CHANGE,
    UNKNOWN,
}
export interface CmpsScoreSectionTrendTooltipValue {
    label: string;
    value: string;
}

export interface CmpsScoreSectionMenuData {
    dropdownMenuValues: CmpsScoreSectionMenuItem[];
}
export interface CmpsScoreSectionMenuItem {
    value: string;
    id: number;
    selected: boolean;
}
